import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';

import Icon from '../icon/Icon';

import './CloseButton.scss';

export interface CloseButtonProps
  extends ComponentPropsWithoutRef<ElementType> {
  component?: ElementType;
  className?: string;
}

const CloseButton = ({
  component: Component = 'button',
  className,
  ...props
}: CloseButtonProps) => {
  return (
    <Component className={classnames('close-button', className)} {...props}>
      <Icon className="close-button-icon" name="cross-bold" />
    </Component>
  );
};

export default CloseButton;
